<h2 mat-dialog-title>{{ 'Editar nombre Archivo/Directorio' }}</h2>

<mat-dialog-content>
  <div class="seleccion">
    <mat-form-field appearance="outline" class="full-width" *ngIf="true">
      <mat-label>Número de orden</mat-label>
      <input matInput type="text">
      <!-- <mat-icon matPrefix></mat-icon> -->
      <!-- <mat-error *ngIf="contactForm.get('orderNumber')?.errors">
        Por favor escriba un número de orden válido.
      </mat-error> -->
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div>
    <button mat-raised-button color="primary" (click)="onCancel()">
      {{ 'Cancel' }}
    </button>
  </div>
</mat-dialog-actions>